import { render, staticRenderFns } from "./HomeBox.vue?vue&type=template&id=44039fe3&scoped=true&"
import script from "./HomeBox.vue?vue&type=script&lang=js&"
export * from "./HomeBox.vue?vue&type=script&lang=js&"
import style0 from "./HomeBox.vue?vue&type=style&index=0&id=44039fe3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44039fe3",
  null
  
)

export default component.exports